import { MagicConfigMixin, formatCurrency, throttle, Debounce, deviceChange, isMobileQuery, isDesktopQuery, CssDevice } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import '../../services/interface/methods.js';
import { BREAKPOINT_DEVICE_QUERY, BALANCE_CURRENCY_UPDATED, BREAKPOINT_LANDSCAPE_UPDATED } from '@gig/magic-messages';
import '../../services/wallet.service.js';
import '../../services/payment/payment.service.js';
import { PlatformDeviceType } from '../../services/payment/payment.interface.js';
import '../../services/interface/events.js';
import { QUICK_DEPOSIT_NAMESPACE, IPaymentResult } from '../../store/modules/quick-deposit/quick-deposit.constants.js';
import '../../store/modules/quick-deposit/quick-deposit.store.js';
import { RESUME_DEPOSIT_NAMESPACE } from '../../store/modules/resume-deposit/resume-deposit.constants.js';
import '../../store/modules/resume-deposit/resume-deposit.store.js';
import { store } from '../../store/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const quickDepositModule = namespace(QUICK_DEPOSIT_NAMESPACE);
const resumeDepositModule = namespace(RESUME_DEPOSIT_NAMESPACE);
let QuickDepositComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.currency = null;
    this.isMobile = null;
    this.isPlacedTop = null;
    this.vertical = false;
    this.selectedCard = "";
    this.cvv = "";
    this.amount = "";
    this.limitsMessage = "";
    this.limitsValid = false;
    this.service = "";
  }
  created() {
    return __async(this, null, function* () {
      this.deviceSubscription = deviceChange(() => __async(this, null, function* () {
        this.isMobile = yield isMobileQuery();
        const isDesktop = yield isDesktopQuery();
        const cssDevice = yield window.queryBus.query(BREAKPOINT_DEVICE_QUERY);
        this.isPlacedTop = isDesktop && [CssDevice.TABLET, CssDevice.PHABLET, CssDevice.MOBILE].indexOf(cssDevice) !== -1;
      }));
      yield this.initSavedCards();
      if (this.savedCards.length) {
        this.selectedCard = this.savedCards[0].value;
      }
      this.currencySubscription = window.eventBus.subscribe(BALANCE_CURRENCY_UPDATED, (e) => {
        this.currency = e.payload;
      }, { replay: true });
      this.verticalSubscription = window.eventBus.subscribe(BREAKPOINT_LANDSCAPE_UPDATED, (e) => __async(this, null, function* () {
        if (yield isMobileQuery()) {
          this.vertical = e.payload;
        }
      }), { replay: true });
    });
  }
  destroyed() {
    var _a, _b, _c;
    (_a = this.verticalSubscription) == null ? void 0 : _a.unsubscribe();
    (_b = this.currencySubscription) == null ? void 0 : _b.unsubscribe();
    (_c = this.deviceSubscription) == null ? void 0 : _c.unsubscribe();
  }
  onDeposit() {
    return __async(this, null, function* () {
      if (this.depositDisabled) {
        return;
      }
      const { selectedCard, amount, cvv, service } = this;
      const device = this.getPaymentDevice();
      if (selectedCard && amount && cvv) {
        const parsedAmount = parseFloat(amount);
        this.emitAttempt(parsedAmount);
        const { resumeDeposit } = yield this.deposit({
          selectedCard,
          amount: parsedAmount,
          cvv,
          device,
          service
        });
        this.cvv = "";
        if (resumeDeposit) {
          this.setResumeDeposit(resumeDeposit);
          this.routeTo({
            route: this.RoutablePage.WALLET_DEPOSIT,
            query: {
              gamePath: this.gamePath
            }
          });
        }
      }
    });
  }
  onChangeAmount() {
    this.limitsValid = false;
    this.setLimitsMessage();
  }
  setLimitsMessage() {
    const savedCard = this.savedCards.find((card) => card.value === this.selectedCard);
    const amount = parseFloat(this.amount);
    let limit = { min: 0, max: 0 };
    if (savedCard) {
      limit = savedCard.limit;
    }
    if (amount > limit.max || amount < limit.min) {
      this.limitsValid = false;
      this.limitsMessage = this.$t("quick-deposit.amount-limits", {
        min: formatCurrency(limit.min, this.currency),
        max: formatCurrency(limit.max, this.currency)
      });
      return;
    }
    this.limitsValid = true;
    this.limitsMessage = "";
  }
  get showSuccessMessage() {
    return !this.paymentProcessing && this.paymentResult === IPaymentResult.SUCCESS;
  }
  get showErrorMessage() {
    return !this.paymentProcessing && this.paymentResult === IPaymentResult.ERROR;
  }
  get depositDisabled() {
    return !this.cvv || !this.amount || !this.limitsValid;
  }
  get toolTipPosition() {
    return this.isPlacedTop ? "top" : "bottom";
  }
  getPaymentDevice() {
    if (this.magicConfig.desktop) {
      return PlatformDeviceType.DESKTOP;
    }
    if (this.magicConfig.tablet) {
      return PlatformDeviceType.TABLET;
    }
    return PlatformDeviceType.MOBILE;
  }
  onResult() {
    if (this.paymentProcessing) {
      return;
    }
    if (this.paymentResult === IPaymentResult.SUCCESS) {
      this.emitSuccess(parseFloat(this.amount));
    }
    if (this.paymentResult === IPaymentResult.ERROR) {
      this.emitError(parseFloat(this.amount), this.paymentErrorStatusCode);
    }
  }
  onFocus() {
    throttle(this.emitFocus, 100);
  }
  emitFocus() {
    return true;
  }
  emitAttempt(amount) {
    return amount;
  }
  emitError(amount, error) {
    return { amount, error };
  }
  emitSuccess(amount) {
    return amount;
  }
};
__decorateClass([
  Prop(String)
], QuickDepositComponent.prototype, "gamePath", 2);
__decorateClass([
  quickDepositModule.Getter("savedCards")
], QuickDepositComponent.prototype, "savedCards", 2);
__decorateClass([
  quickDepositModule.Getter("paymentProcessing")
], QuickDepositComponent.prototype, "paymentProcessing", 2);
__decorateClass([
  quickDepositModule.Getter("paymentResult")
], QuickDepositComponent.prototype, "paymentResult", 2);
__decorateClass([
  quickDepositModule.Getter("paymentErrorStatusCode")
], QuickDepositComponent.prototype, "paymentErrorStatusCode", 2);
__decorateClass([
  quickDepositModule.Action("initSavedCards")
], QuickDepositComponent.prototype, "initSavedCards", 2);
__decorateClass([
  quickDepositModule.Action("deposit")
], QuickDepositComponent.prototype, "deposit", 2);
__decorateClass([
  resumeDepositModule.Action("setResumeDeposit")
], QuickDepositComponent.prototype, "setResumeDeposit", 2);
__decorateClass([
  Debounce(300)
], QuickDepositComponent.prototype, "setLimitsMessage", 1);
__decorateClass([
  Watch("paymentResult")
], QuickDepositComponent.prototype, "onResult", 1);
__decorateClass([
  Emit("focus")
], QuickDepositComponent.prototype, "emitFocus", 1);
__decorateClass([
  Emit("attempt")
], QuickDepositComponent.prototype, "emitAttempt", 1);
__decorateClass([
  Emit("error")
], QuickDepositComponent.prototype, "emitError", 1);
__decorateClass([
  Emit("success")
], QuickDepositComponent.prototype, "emitSuccess", 1);
QuickDepositComponent = __decorateClass([
  Component({
    store,
    name: "quick-deposit"
  })
], QuickDepositComponent);

export default QuickDepositComponent;
